import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the count of unreviewed facility pre-release updates routed to this
 *  therapist, for the "Pre-Release" nav badge. */
export function usePreReleaseUpdates(intervalMs = 60000) {
    const [count, setCount] = useState(0);
    useEffect(() => {
        let active = true;
        const fetchCount = () => api.get("/provider/prerelease/count")
            .then((r) => { if (active) setCount(r.data.count || 0); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        return () => { active = false; clearInterval(id); };
    }, [intervalMs]);
    return count;
}
